import {
  computed,
  Injectable,
  resource,
  ResourceRef,
  Signal,
} from '@angular/core';
import { ILanguage } from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { firstValueFrom } from 'rxjs';
import { LanguageGateway } from './language.gateway';

@Injectable({
  providedIn: 'root',
})
export class LanguageStore {
  private readonly gateway: LanguageGateway = new LanguageGateway();

  readonly #languageResource: ResourceRef<
    IApiResponse<ILanguage[]> | undefined
  > = resource({
    loader: (): Promise<IApiResponse<ILanguage[]>> => {
      return firstValueFrom(this.gateway.get());
    },
  });

  readonly isLoading: Signal<boolean> = computed((): boolean =>
    this.#languageResource.isLoading()
  );
  readonly languages: Signal<ILanguage[]> = computed((): ILanguage[] => {
    return this.#languageResource.hasValue()
      ? (this.#languageResource.value()?.data ?? [])
      : [];
  });

  readonly activeLanguages: Signal<ILanguage[]> = computed(() => {
    return this.languages().filter((language: ILanguage) => language.isActive);
  });

  loadLanguage(): void {
    this.#languageResource.reload();
  }

  deleteLanguage(languageId: string): void {
    firstValueFrom(this.gateway.delete(languageId)).then(() => {
      this.loadLanguage();
    });
  }

  save(query: ILanguage[]): void {
    firstValueFrom(this.gateway.save(query)).then(
      (result: IApiResponse<ILanguage[]>): void => {
        if (result && result.data) {
          this.#languageResource.reload();
        }
      }
    );
  }
}
